import Layer from './Layer';
import QubitsImage from '../images/QubitsImage';

const qubitsLayer: Layer = {
  PlaneImage: QubitsImage,
  anchorPositionX: 0.12,
  anchorPositionY: 0.4062,
  collapsedOffsetY: 0.057,
  description: `
    Transmon qubits attached to an interposer chip through bump bonds offer hardware simplicity in a
    scalable architecture with controllable features.
  `,
  name: 'Qubit plane',
  openOffsetY: 0,
  type: 'openable',
};

export default qubitsLayer;
